import { configureStore } from "@reduxjs/toolkit";
import jobsReducer from "../features/Job/jobSlice";
import filtersReducer from "../features/filter/filterSlice";

const store = configureStore({
    reducer: {
        jobs: jobsReducer,
        filters: filtersReducer
    },
});

export default store;